import {initialDataActionTypes} from "../actions/actionTypes";

export const initialState = {
    email: '',
    token: '',
    uiFlow: '',
    distributionChannel: '',
    enrollmentPlatformLink: '',
    gender: '',
    isMember: false,
    isConcierge: false,
    isPaperEnrollment: false,
    isNewHire: null,
    dateOfHire: null,
    ageAtPolicyEffectiveDate: null,
    notSaveUserProgress: false,
    isBillingEnabled: false,
    maritalStatusOptions: [],
    dependentsOptions: [],
    conditionFilterOptions: [],
    highDeductibleOptions: [],
    coPayOptions: [],
    disposableIncomeOptions: [],
    coverageOptions: [],
    costPerOptions: [],
    stateOptions: [],
    genderOptions: [],
    relationshipOptions: [],
    nameSuffixOptions: [],
    phoneTypeOptions: [],
    studentStatusOptions: [],
    increments: {},
    quoteInfo: {},
    contractType: null,
    employerContribution: {},
    presets: {},
    ratedClass: {
        contractTerms: {
            employerContributions: null,
            contributionType: null,
            groupClass: null,
            contractTerms: null,
            ratedClassRates: null,
        }
    },
    policy: {
        ageReduction: null,
        benefitWaitingPeriod: null,
        maxEligibilityAge: null,
        minEligibilityAge: null,
        childMaxEligibilityAge: null,
        ageReductionPercentage: null,
        ageReductionAge: null,
        polEDate: null,
        severeSeparationPeriod: null,
        moderateSeparationPeriod: null,
        catastrophicSeparationPeriod: null,
        catastrophicRecurrencyLimit: null,
    },
    employer: {},
    payrollFrequencyMonthly: '',
    payrollFrequencySelected: '',
    contractInfo: {
        employerName: '',
        effectiveDate: '',
        moderate: null,
        severe: null,
        catastrophic: null,
        chronic: null,
        mental: null,
        tiers: null,
        riderSelection: null,
        planOffering: '',
        accountId: '',
        questions: [],
    },
    declineReasons: [],
    openEnrollment: {
        enrollmentStartDate: null,
        enrollmentEndDate: null,
    },
    eeCensusAddress: {},
    eligibility: {
        domesticPartnerEligible: null,
        civilUnionEligible: null,
    },
    hostname: null,
    limitations: [],
    frauds: [],
    disclaimers: [],
    riderLabels: {},
    enrollmentDeclined: false,
    reviewCustomLanguage: {
        generic: null,
        attestationDisclaimer: {
            attestationDisclaimer: null,
            conditionalValues: {
                andMembers: null,
                authorizingPremiumDeduction: null,
                acceptingCoverageAtNoCost: null,
            },
        },
        consentNotice: null,
        insuranceTerm: null,
        limitedBenefitsWarning: null,
        medicareWarning: null,
        misrepresentationWarning: null,
        minimumCoverageWarning: null,
        notSubstituteDisclaimer: null,
        notSubstituteWarning: null,
        customLanguageMinimumCoverageWarning: null,
    },
};

export const initialDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case initialDataActionTypes.SET_INITIAL_DATA:
            const data = action.payload;
            const contractInfo = data.contractInfo;

            return {
                ...state,
                token: data.token,
                email: data.email,
                isMember: data.isMember,
                hasAccount: data.hasAccount,
                isConcierge: data.isConcierge,
                isPaperEnrollment: data.isPaperEnrollment,
                notSaveUserProgress: data.notSaveUserProgress,
                maritalStatusOptions: data.maritalStatusOptions,
                dependentsOptions: data.dependentsOptions,
                conditionFilterOptions: data.conditionFilterOptions,
                highDeductibleOptions: data.highDeductibleOptions,
                coPayOptions: data.coPayOptions,
                disposableIncomeOptions: data.disposableIncomeOptions,
                coverageOptions: data.familyTiers,
                costPerOptions: data.costPerOptions,
                stateOptions: data.stateOptions,
                genderOptions: data.genderOptions,
                relationshipOptions: data.relationshipOptions,
                phoneTypeOptions: data.phoneTypeOptions,
                nameSuffixOptions: data.nameSuffixOptions,
                studentStatusOptions: data.studentStatusOptions,
                uiFlow: data.uiFlow,
                distributionChannel: data.distributionChannel,
                enrollmentPlatformLink: data.enrollmentPlatformLink,
                ratedClass: {
                    contractTerms: data.ratedClass.contractTerms,
                    ratedClassRates: data.ratedClass.ratedClassRates,
                },
                policy: {
                    ageReduction: data.policy?.ageReduction,
                    benefitWaitingPeriod: data.policy?.benefitWaitingPeriod,
                    maxEligibilityAge: data.policy?.maxEligibilityAge,
                    minEligibilityAge: data.policy?.minEligibilityAge,
                    childMaxEligibilityAge: data.policy?.childMaxEligibilityAge,
                    ageReductionPercentage: data.policy?.ageReductionPercentage,
                    ageReductionAge: data.policy?.ageReductionAge,
                    polEDate: data.policy?.polEDate,
                    severeSeparationPeriod: data.policy?.severeSeparationPeriod,
                    moderateSeparationPeriod: data.policy?.moderateSeparationPeriod,
                    catastrophicSeparationPeriod: data.policy?.catastrophicSeparationPeriod,
                    catastrophicRecurrencyLimit: data.policy?.catastrophicRecurrencyLimit,
                },
                employer: data.employer,
                payrollFrequencyMonthly: data.payrollFrequencyMonthly,
                payrollFrequencySelected: data.payrollFrequencySelected,
                increments: data.increments,
                presets: data.presets,
                quoteInfo: data.quoteInfo,
                contractType: data.contractType,
                contractInfo: {
                    employerName: contractInfo.employerName,
                    moderate: contractInfo.moderate,
                    severe: contractInfo.severe,
                    catastrophic: contractInfo.catastrophic,
                    chronic: contractInfo.chronic,
                    mental: contractInfo.mental,
                    tiers: contractInfo.tiers,
                    effectiveDate: contractInfo.effectiveDate,
                    riderSelection: contractInfo.riderSelection,
                    planOffering: contractInfo.planOffering,
                    accountId: contractInfo.accountId,
                    groupType: contractInfo.groupType,
                    issueState: contractInfo.issueState,
                    questions: contractInfo.questions,
                },
                declineReasons: data.declineReasons.map((d) => {
                    return {
                        key: d.key,
                        text: d.text,
                        value: d.value,
                    }
                }),
                eligibility: {
                    domesticPartnerEligible: data.eligibility?.domesticPartnerEligible,
                    civilUnionEligible: data.eligibility?.civilUnionEligible,
                },
                hostname: data.hostname,
                limitations: data.limitations,
                frauds: data.frauds,
                disclaimers: data.disclaimers,
                paymentDetails: data.paymentDetails,
                isBillingEnabled: data.isBillingEnabled,
                conditionListVersionSfId: data.conditionListVersionSfId,
                riderLabels: data.riderLabels,
                enrollmentDeclined: data.enrollmentDeclined,
                reviewCustomLanguage: data.reviewCustomLanguage,
            };
        case initialDataActionTypes.CLEAR_INITIAL_DATA:
            return {...initialState};
        case initialDataActionTypes.SET_CENSUS_EE_ADDRESS: {
            const data = action.payload;
            return {
                ...state,
                eeCensusAddress: {
                    zipCode: data.eeCensusAddress.zipCode,
                    street: data.eeCensusAddress.street,
                    state: data.eeCensusAddress.state,
                    country: data.eeCensusAddress.country,
                    city: data.eeCensusAddress.city,
                }
            }
        }
        case initialDataActionTypes.SET_VERIFY_RESPONSE_DATA: {
            const data = action.payload;
            const openEnrollment = {
                enrollmentStartDate: data.enrollmentStartDate,
                enrollmentEndDate: data.enrollmentEndDate
            }
            return {
                ...state,
                employerContribution: data.employerContribution,
                ageAtPolicyEffectiveDate: data.ageAtPolicyEffectiveDate,
                gender: data.gender,
                openEnrollment: {...openEnrollment},
                payrollFrequencySelected: data.payrollFrequencySelected,
                isNewHire: data.isNewHire,
                dateOfHire: data.dateOfHire,
                coverageEffectiveDate: data.coverageEffectiveDate,
            }
        }
        case initialDataActionTypes.SET_ET_CONTRACT_TERMS_DATA: {
            const data = action.payload;
            return {
                ...state,
                policy: {
                    ageReduction: data.policy.ageReduction,
                    benefitWaitingPeriod: data.policy.benefitWaitingPeriod,
                    maxEligibilityAge: data.policy.maxEligibilityAge,
                    minEligibilityAge: data.policy.minEligibilityAge,
                    childMaxEligibilityAge: data.policy.childMaxEligibilityAge,
                    ageReductionPercentage: data.policy.ageReductionPercentage,
                    ageReductionAge: data.policy.ageReductionAge,
                    polEDate: data.policy.polEDate,
                    severeSeparationPeriod: data.policy.severeSeparationPeriod,
                    moderateSeparationPeriod: data.policy.moderateSeparationPeriod,
                    catastrophicSeparationPeriod: data.policy.catastrophicSeparationPeriod,
                    catastrophicRecurrencyLimit: data.policy.catastrophicRecurrencyLimit,
                },
                eligibility: {
                    domesticPartnerEligible: data.eligibility.domesticPartnerEligible,
                    civilUnionEligible: data.eligibility.civilUnionEligible,
                },
                limitations: data.limitations,
                frauds: data.frauds,
            }
        }
        case initialDataActionTypes.SET_IS_MEMBER: {
            const data = action.payload;
            return {
                ...state,
                isMember: data.isMember,
            }
        }
        case initialDataActionTypes.SET_ENROLLMENT_DECLINED: {
            const data = action.payload;
            return {
                ...state,
                enrollmentDeclined: data.enrollmentDeclined,
            }
        }
        default:
            return state
    }
};
